import React, { FC, PropsWithChildren } from 'react';
import styles from './commonButton.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

interface Props {
  className?: string;
  disabled?: boolean;
  type: 'green' | 'white' | 'black';

  onClick?: () => void;
}

export const CommonButton: FC<PropsWithChildren<Props>> = (props) => {
  const { disabled, type, onClick, className, children } = props;
  return (
    <button className={cx('button', type, className)} disabled={disabled} onClick={onClick}>
      {children}
    </button>
  );
};
